import Vue from "vue";

Vue.prototype.$scrollOntop = function() {if (process.client) { window.scrollTo(0, 0); }};